import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from './config/constants';
import { save } from './core/save';
import { installDebug } from './debug';
import { AssetPreviewScene } from './scenes/AssetPreviewScene';
import { VersusLobbyScene } from './scenes/VersusLobbyScene';
import { VersusScene } from './scenes/VersusScene';
import { BootScene } from './scenes/BootScene';
import { GameScene } from './scenes/GameScene';
import { HangarScene } from './scenes/HangarScene';
import { MenuScene } from './scenes/MenuScene';
import { PauseScene } from './scenes/PauseScene';
import { ResultsScene } from './scenes/ResultsScene';
import { RewardScene } from './scenes/RewardScene';
import { RouteScene } from './scenes/RouteScene';
import { SettingsScene } from './scenes/SettingsScene';
import { StationScene } from './scenes/StationScene';
import { UIScene } from './scenes/UIScene';

save.load();

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#05070b',
  scale: { mode: Phaser.Scale.FIT, autoCenter: Phaser.Scale.CENTER_BOTH },
  physics: {
    default: 'arcade',
    // 120 Hz fixed step: smooth on high-refresh displays and no tunnelling during dashes.
    arcade: { gravity: { x: 0, y: 0 }, fps: 120, fixedStep: true, tileBias: 32, debug: false },
  },
  input: { gamepad: true, mouse: { preventDefaultWheel: true } },
  render: { antialias: true, pixelArt: false, roundPixels: false, powerPreference: 'high-performance' },
  disableContextMenu: true,
  fps: { target: 60, smoothStep: true },
  scene: [
    BootScene,
    MenuScene,
    HangarScene,
    GameScene,
    UIScene,
    RewardScene,
    RouteScene,
    StationScene,
    PauseScene,
    ResultsScene,
    SettingsScene,
    AssetPreviewScene,
    VersusLobbyScene,
    VersusScene,
  ],
});

if (new URLSearchParams(window.location.search).has('debug')) {
  installDebug(game);
}
